import {PhotoLibrary} from './pages/PhotoLibrary';import React from 'react';import ReactDOM from 'react-dom/client';import {BrowserRouter,Routes,Route} from 'react-router-dom';import {ContentProvider} from './hooks/useContent';import {Shell} from './components/Shell';import {Home} from './pages/Home';import {Jobs,JobDetail} from './pages/Jobs';import {Journal,ArticleDetail} from './pages/Journal';import {Journey,Training,Audience,Contact} from './pages/Journeys';import {About,Ecosystem,Network,CountryDetail,Services,ServiceDetail,Projects,NotFound} from './pages/Corporate';import {Admin} from './pages/Admin';import {AgentWorkspace} from './pages/AgentWorkspace';import {CandidateProfile} from './pages/CandidateProfile';import './styles.css';import './styles/corporate-premium.css';import './styles/journal-premium.css';import './styles/journeys-premium.css';import './styles/admin-premium.css';import './styles/jobs-premium.css';import './styles/reference-system.css';
ReactDOM.createRoot(document.getElementById('root')!).render(<React.StrictMode><LanguageProvider><BrowserRouter><ContentProvider><Routes><Route path="admin-preview" element={<Admin/>}/><Route element={<Shell/>}><Route index element={<Home/>}/><Route path="tro-ly" element={<AgentWorkspace/>}/><Route path="ho-so-ung-vien" element={<CandidateProfile/>}/><Route path="co-hoi" element={<Jobs/>}/><Route path="co-hoi/:id" element={<JobDetail/>}/><Route path="dao-tao-quoc-te" element={<Training/>}/><Route path="lo-trinh" element={<Journey/>}/><Route path="thu-vien" element={<PhotoLibrary/>}/><Route path="cam-nang" element={<Journal/>}/><Route path="cam-nang/:id" element={<ArticleDetail/>}/><Route path="tin-tuc" element={<Journal news/>}/><Route path="ung-vien" element={<Audience persona="candidate"/>}/><Route path="doanh-nghiep" element={<Audience persona="employer"/>}/><Route path="linh-vuc" element={<Services/>}/><Route path="linh-vuc/:id" element={<ServiceDetail/>}/><Route path="he-sinh-thai" element={<Ecosystem/>}/><Route path="mang-luoi" element={<Network/>}/><Route path="mang-luoi/:id" element={<CountryDetail/>}/><Route path="du-an" element={<Projects/>}/><Route path="ve-nibelc" element={<About/>}/><Route path="lien-he" element={<Contact/>}/><Route path="*" element={<NotFound/>}/></Route></Routes></ContentProvider></BrowserRouter></LanguageProvider></React.StrictMode>);

import './styles/editorial-masthead-v2.css';

import './styles/editorial-sections.css';

import './styles/bright-banners.css';

import './styles/network-home.css';

import './styles/tech-header.css';
import './styles/glass-surfaces.css';

import './styles/page-transition.css';

import './styles/footer-tech.css';

import './styles/mobile-banners.css';

import './styles/training-hero.css';

import './styles/training-paths.css';

import './styles/logo-band.css';

import './styles/network-hero-logo.css';

import './styles/home-metrics.css';

import './styles/header-slim.css';

import './styles/home-mobile.css';

import './styles/header-cap.css';

import './styles/robot-pet.css';
import './styles/mobile-title-alignment.css';
import {LanguageProvider} from './i18n/LanguageProvider';

import './styles/menu-tech.css';

import './styles/balanced-titles.css';

import './styles/perf-mobile.css';

import './styles/title-balance.css';

import './styles/qa-r10.css';

import './styles/website-network.css';
import './styles/header-consistent.css';
